import { render } from "./ProductSlide.vue?vue&type=template&id=3b8a2a99&scoped=true"
import script from "./ProductSlide.vue?vue&type=script&lang=js"
export * from "./ProductSlide.vue?vue&type=script&lang=js"

import "./ProductSlide.vue?vue&type=style&index=0&id=3b8a2a99&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8a2a99"]])

export default __exports__